import { render, staticRenderFns } from "./changeOrderTools.vue?vue&type=template&id=64b31f70&scoped=true&"
import script from "./changeOrderTools.vue?vue&type=script&lang=js&"
export * from "./changeOrderTools.vue?vue&type=script&lang=js&"
import style0 from "./changeOrderTools.vue?vue&type=style&index=0&id=64b31f70&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b31f70",
  null
  
)

export default component.exports